<template>
    <!-- cart table template -->
    <p style="text-align:center;" v-show="Cart.CartItems == null || Cart.CartItems.length == 0">{{getInterfaceText('shop_cart_empty')}}</p>
    <p class="sr-only">{{getInterfaceText('shoppingcart')}}</p>
    <!-- SK 07-05-2024 convert table to divs -->
    <div id="cart" v-show="Cart.CartItems != null && Cart.CartItems.length > 0">
        <!-- head -->
        <div id="cart-head">
            <div class="product" scope="col">{{getInterfaceText('shop_product')}}</div>
            <div class="hidden-xs"></div>
            <div class="price hidden-xs" scope="col">{{getInterfaceText('shop_price')}}</div>
            <div class="quantity" scope="col"><span class="full-label">{{getInterfaceText('shop_quantity')}}</span><span class="short-label">{{getInterfaceText('shop_qty')}}</span></div>
            <div class="total" scope="col">{{getInterfaceText('shop_total')}}</div>
            <div v-if="editMode" class="action" scope="col">&nbsp;</div>            
        </div>
        <ul id="cart-rows">
            <li v-for="item in Cart.CartItems" role="group" aria-label="item" :id="'cartItem-'+ item.Product.Partnumber.Code" :key="item.Id" :class="[(item.SupplementaryToCartItemId != null ? 'suppplementaryItem' : item.ParentId > 0 ? 'bundleItem' : ''), 'cartItem clearfix']">
                
                <!-- COL 1-->
                <div scope="row" class="product-image" nowrap="nowrap">

                    <div class="image" :class="item.GiftcardsRecipient != null ? 'image-giftcard' : ''">
                        <img v-if="item.IsGlobalCatalogue" :alt="item.Product.Name" :src="item.Product.Image">
                        <img v-if="item.IsGlobalCatalogue == false" :alt="item.Product.Name" :src="item.Product.Image + '?quality=80&amp;width=100&amp;height=80&amp;mode=pad&amp;bgcolor=white&amp;anchor=middlecenter'">
                    </div>

                </div>

                <!-- COL 2-->
                <div class="product-specs">
                    <h4 class="name">
                        <a :href="item.Product.UrlLabel" rel="nofollow"><span v-if="item.ParentId > 0" class="supplementary-plus"><i class="glyphicon glyphicon-plus"></i></span> {{item.Product.Name}}</a><br />
                    </h4>

                    <!-- price / total -->
                    <div class="price" style="white-space: nowrap;">{{item.Product.Partnumber.Price}}</div>
                    <div class="row-total">
                        <span style="white-space: nowrap;">
                            <span class="sr-only">{{getInterfaceText('shop_price')}} {{item.TotalToFormat}}</span>
                            <span class="sr-only" v-if="item.TotalOriginalPriceToFormat && item.TotalOriginalPriceToFormat.length > 0">{{getInterfaceText('shop_price_original')}} {{item.TotalOriginalPriceToFormat}}</span>
                            <div class="cartItem-total">{{item.TotalToFormat}}</div>
                            <span class="cartItem-total oldprice">{{item.TotalOriginalPriceToFormat}}</span>
                        </span>
                    </div>

                    <div class="color-and-size">
                        <span class="color" v-if="item.Product.Partnumber.Color != null && item.Product.Partnumber.Color != ''">{{item.Product.Partnumber.Color}}</span>
                        <span class="divider" v-if="item.Product.Partnumber.Color != null && item.Product.Partnumber.Color != '' && item.Product.Partnumber.Size != null">|</span>
                        <span class="size" v-if="item.Product.Partnumber.Size != null">{{item.Product.Partnumber.Size}}</span>
                    </div>

                    <div class="usage" v-if="item.Product.Partnumber.Usage != null">{{item.Product.Partnumber.Usage}}</div>
                    
                    <div class="sale" v-if="item.Product.IsCloseOutSale && item.Product.IsSale" v-html="getInterfaceText('shop_iscloseoutsale_message')"></div>
                    
                    <div v-if="item.GiftcardsRecipient != null"><span class="giftcard-label">{{getInterfaceText('giftcard_recipient')}}:</span> {{item.GiftcardsRecipient}}</div>
                    <div v-if="item.GiftcardsSenddate != null"><span class="giftcard-label">{{getInterfaceText('giftcard_send')}}:</span> {{item.GiftcardsSenddate}}</div>
                    <div class="stock-info">
                        <span class="stock {{item.Stock.CssClass}}" v-show="item.Stock.Code == 3">{{item.Stock.Label}}</span>
                    </div>
                    

                </div>

                <!-- COL 3 -->
                <div class="product-quantity-and-trash">

                    <div class="remove" v-if="editMode">
                        <button type="button" class="btn-link remove-cart-item" v-on:click="removeCartItem(item)" :aria-label="getInterfaceText('shop_removethisitem')"><i class="glyphicon glyphicon-trash" aria-hidden="true"></i></button>
                    </div>
                     
                    <div class="quantity" v-if="item.SupplementaryToCartItemId == null && item.ParentId == 0">
                        <template v-if="editMode">
                            <select name="quantity" :aria-label="'Quantity for '+ item.Product.Name" v-on:change="setCartItemQuantity(item, $event)" v-show="item.Product.ProductTypeId != 3">
                                <option v-for="i in 10" :key="i" :value="i" :selected="i == item.Quantity">{{i}}</option>
                            </select>

                            <!--
                                <div class="btn-group" role="group" aria-label="Quantity" v-show="item.Product.ProductTypeId != 3">
                                 <button v-on:click="updateCartItem(item, -1)" type="button" class="btn btn-default update-cart-item" :aria-label="getInterfaceText('shop_decrease_quantity')"><i class="glyphicon glyphicon glyphicon-minus" aria-hidden="true"></i></button>
                                 <span class="btn btn-default btn-disable" :aria-label="getInterfaceText('shop_cart_quantity')"><span class="cartItem-quantity">{{item.Quantity}}</span></span>
                                 <button v-on:click="updateCartItem(item, 1)" type="button" class="btn btn-default update-cart-item" :aria-label="getInterfaceText('shop_increase_quantity')"><i class="glyphicon glyphicon glyphicon-plus" aria-hidden="true"></i></button>
                                 </div>
                                     -->

                        </template>
                        <template v-else>
                            <span class="quantity">{{item.Quantity}}</span>
                        </template>
                    </div>

                    <div class="quantity-readonly" v-if="item.SupplementaryToCartItemId != null || item.ParentId > 0">
                        {{item.Quantity}}
                    </div>


                </div>

               
            </li>
        </ul>
    </div>

</template>
<script>
    import cartMixin from '../mixins/cart-mixin.js';
    import generalMixin from '../mixins/general.js';
    export default {
        name: 'cart-table',
        mixins: [cartMixin, generalMixin],
        props: ['editMode', 'summaryMode'],
        template: '#cart-table-template',
        data: function () {
            return {
                ProductPriceExcludedTax: false,
                ShowGiftcardOrCouponPanel: false,
                ShowTaxInclusiveTag: false
            }
        },
        methods: {
            // See cartMixin
        },
        computed: {
            // See cartMixin
        },
        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-cart-parameters').dataset.interfacetexts);
        }
    }
</script>
